import React from 'react';
import classNames from 'classnames';
import SkeletonAvatar from './Avatar';
import SkeletonButton from './Button';
import SkeletonImage from './Image';
import SkeletonInput from './Input';
import Paragraph from './Paragraph';
import Title from './Title';
import Element from './Element';
import configContext from './configContext';
function getComponentProps(prop) {
  if (prop && typeof prop === 'object') {
    return prop;
  }
  return {};
}
function getAvatarBasicProps(hasTitle, hasParagraph) {
  if (hasTitle && !hasParagraph) {
    return { size: 'large', shape: 'square' };
  }
  return { size: 'large', shape: 'circle' };
}
function getTitleBasicProps(hasAvatar, hasParagraph) {
  if (hasAvatar && hasParagraph) {
    return { width: '50%' };
  }
  if (!hasAvatar && hasParagraph) {
    return { width: '38%' };
  }
  return {};
}
function getParagraphBasicProps(hasAvatar, hasTitle) {
  const basicProps = {};
  if (!hasAvatar || !hasTitle) {
    basicProps.width = '61%';
  }
  if (!hasAvatar && hasTitle) {
    basicProps.rows = 3;
  } else {
    basicProps.rows = 2;
  }
  return basicProps;
}
const Skeleton = props => {
  const renderSkeleton = ({ getPrefixCls, direction }) => {
    const {
      prefixCls: customizePrefixCls,
      loading,
      className,
      children,
      avatar,
      title,
      paragraph,
      active,
      round,
    } = props;
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    if (loading || !('loading' in props)) {
      const hasAvatar = !!avatar;
      const hasTitle = !!title;
      const hasParagraph = !!paragraph;

      // let avatarNode;
      // if (hasAvatar) {
      // }

      // let contentNode;
      // if (hasTitle || hasParagraph) {
      // }

      // const cls = classNames(prefixCls);
      // Avatar
      let avatarNode;
      if (hasAvatar) {
        const avatarProps = {
          prefixCls: `${prefixCls}-avatar`,
          ...getAvatarBasicProps(hasTitle, hasParagraph),
          ...getComponentProps(avatar),
        };
        // We direct use SkeletonElement as avatar in skeleton internal.
        avatarNode = (
          <div className={`${prefixCls}-header`}>
            <Element {...avatarProps} />
          </div>
        );
      }

      let contentNode;
      if (hasTitle || hasParagraph) {
        // Title
        let $title;
        if (hasTitle) {
          const titleProps = {
            prefixCls: `${prefixCls}-title`,
            ...getTitleBasicProps(hasAvatar, hasParagraph),
            ...getComponentProps(title),
          };

          $title = <Title {...titleProps} />;
        }

        // Paragraph
        let paragraphNode;
        if (hasParagraph) {
          const paragraphProps = {
            prefixCls: `${prefixCls}-paragraph`,
            ...getParagraphBasicProps(hasAvatar, hasTitle),
            ...getComponentProps(paragraph),
          };

          paragraphNode = <Paragraph {...paragraphProps} />;
        }

        contentNode = (
          <div className={`${prefixCls}-content`}>
            {$title}
            {paragraphNode}
          </div>
        );
      }

      const cls = classNames(
        prefixCls,
        {
          [`${prefixCls}-with-avatar`]: hasAvatar,
          [`${prefixCls}-active`]: active,
          [`${prefixCls}-rtl`]: direction === 'rtl',
          [`${prefixCls}-round`]: round,
        },
        className,
      );
      console.log(1998, cls, avatarNode, contentNode, loading || !('loading' in props));
      return (
        <div className={cls}>
          {avatarNode}
          {contentNode}
        </div>
      );
    }
    console.log(1998, children, props, loading || !('loading' in props));
    return children;
  };
  return <configContext.Consumer>{renderSkeleton}</configContext.Consumer>;
};
Skeleton.defaultProps = {
  avatar: false,
  title: true,
  paragraph: true,
};
Skeleton.Avatar = SkeletonAvatar;
Skeleton.Button = SkeletonButton;
Skeleton.Image = SkeletonImage;
Skeleton.Input = SkeletonInput;
export default Skeleton;



// WEBPACK FOOTER //
// ./src/skeleton/Skeleton.jsx